import { Injectable } from '@angular/core';
import { UnsafeAction } from 'app/actions/UnsafeAction';
import { DisplayReportJob } from 'app/models/ui';

/* tslint:disable */
@Injectable()
export class ReportingActions {

	static SET_REPORT_JOB = "[REPORTING] SET_REPORT_JOB";
	static UPDATE_REPORT_JOB = "[REPORTING] UPDATE_REPORT_JOB";
	static DELETE_REPORT_JOB = "[REPORTING] DELETE_REPORT_JOB";

	public setDisplayReportJob(displayReportJob: DisplayReportJob): UnsafeAction {
		return {
			type: ReportingActions.SET_REPORT_JOB,
			payload: displayReportJob
		};
	};

	public updateDisplayReportJob(displayReportJob: DisplayReportJob): UnsafeAction {
		return {
			type: ReportingActions.UPDATE_REPORT_JOB,
			payload: displayReportJob
		};
	};

	public deleteDisplayReportJob(displayReportJob: DisplayReportJob): UnsafeAction {
		return {
			type: ReportingActions.DELETE_REPORT_JOB,
			payload: displayReportJob
		};
	};
}



// WEBPACK FOOTER //
// ./src/app/components/reporting/reporting.actions.ts